import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import GeneralInflationInput from '../general-inflation';

const GeneralInflationInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <GeneralInflationInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default GeneralInflationInputWithAnalytics;
